import script from "./VisitCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitCard.vue?vue&type=script&setup=true&lang=js"

import "./VisitCard.vue?vue&type=style&index=0&id=cefc970e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cefc970e"]])

export default __exports__